export default class CleanSettings {
  enabled = false;
  cleanType: string = null;

  constructor(data: any = {}) {
    this.enabled = data['enabled'] || false;
    this.cleanType = data['type'] || null;
  }
}
